import urls from "../common/urls"
import { http } from "../common/post"

const SimpleFlowSource = {
  getCardinalSymptoms: token => http(`${urls.getCardinalSymptoms}?diagnosis_token=${token}`, "GET"),
  submitCardinalEvidence: evidence => http(urls.submitCardinalEvidence, "POST", { evidence })
}

export default SimpleFlowSource



// WEBPACK FOOTER //
// ./assets/simpleFlow/Source.js